import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2, Lock, User, Mail, Phone, Globe, X, ArrowRight, Clock, TrendingUp, DollarSign, Zap, Target, Users, Video, Calendar, Ticket, Search, Bot, MessageSquare, Mic, Quote, AlertTriangle, ShieldCheck, Car, Briefcase, HelpCircle, Frown, Sparkles, XCircle, Monitor, Check, CalendarPlus, MessageCircle, Download, ArrowDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
const getNextThursdayDate = () => {
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estTime.getDay();
  const currentHour = estTime.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 19 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const next = new Date(estTime);
  next.setDate(estTime.getDate() + daysUntilThursday);
  next.setHours(19, 0, 0, 0);
  return next;
};
const getThursdayLabel = () => {
  const t = getNextThursdayDate();
  const day = t.getDate();
  const month = t.toLocaleString('es-ES', {
    month: 'long'
  }).toUpperCase();
  return `JUEVES ${day} DE ${month}`;
};
export function EscapaDelDealershipGraciasPage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '4285913388317138');
    window.fbq('trackSingle', '4285913388317138', 'PageView');
    window.fbq('trackSingle', '4285913388317138', 'Lead', {
      content_name: 'Escapa Dealership PDF Download',
      source: '/escapa-del-dealership-gracias'
    });
    window.fbq('trackSingleCustom', '4285913388317138', 'EscapaDelDealership-GraciasView');
    const tick = () => {
      const estNow = new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York'
      }));
      const currentDay = estNow.getDay();
      const currentHour = estNow.getHours();
      let daysUntil = 0;
      if (currentDay === 4) {
        daysUntil = currentHour >= 19 ? 7 : 0;
      } else if (currentDay < 4) {
        daysUntil = 4 - currentDay;
      } else {
        daysUntil = 7 - currentDay + 4;
      }
      const estTarget = new Date(estNow);
      estTarget.setDate(estNow.getDate() + daysUntil);
      estTarget.setHours(19, 0, 0, 0);
      let diffMs = estTarget.getTime() - estNow.getTime();
      if (diffMs < 0) diffMs = 0;
      const days = Math.floor(diffMs / 86400000);
      const hours = Math.floor(diffMs % 86400000 / 3600000);
      const minutes = Math.floor(diffMs % 3600000 / 60000);
      const seconds = Math.floor(diffMs % 60000 / 1000);
      setCountdown({
        days,
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu teléfono');
      return;
    }
    if (!smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Escapa Dealership Webinar Registration'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: `${areaCode}${finalPhone}`,
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: `${areaCode}${finalPhone}`,
          areaCode: areaCode,
          source: '/escapa-del-dealership-gracias',
          page_path: '/escapa-del-dealership-gracias',
          tag: 'escapa-dealership-webinar',
          sms_consent: smsConsent,
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/thank-you');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  const blocks = [{
    icon: Search,
    label: 'BLOQUE 1',
    title: 'La Herramienta En Vivo',
    desc: 'Voy a llenar una lista de 200 dentistas en TU ciudad en menos de 1 minuto. Vas a ver el botón "buscar" y la lista apareciendo. No es magia — es scraping inteligente.'
  }, {
    icon: Bot,
    label: 'BLOQUE 2',
    title: 'Construyo Web Completa Delante Tuyo',
    desc: 'Tomo UN cliente real con permiso. Y delante tuyo armo su web profesional completa con IA. Vas a entender por qué cobramos $1,500.'
  }, {
    icon: MessageSquare,
    label: 'BLOQUE 3',
    title: 'Los Mensajes Que Cierran (Para Vendedores)',
    desc: 'Específicamente para car salesmen: cómo aplicas tu técnica de cierre del showroom a este nuevo contexto. Pantallazos REALES de WhatsApp donde alumnos cerraron $1,200 con UN mensaje.'
  }, {
    icon: Mic,
    label: 'BLOQUE 4',
    title: 'Q&A De 30 Minutos En Vivo',
    desc: 'TÚ me preguntas. Sobre tu ciudad. Tu situación específica. Te respondo en tiempo real.'
  }];
  const thursdayLabel = getThursdayLabel();
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-2073" data-mp="1z3uqirer1y00">
      <noscript data-id="element-2074" data-mp="1u74csaqf3ehr">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=4285913388317138&ev=PageView&noscript=1" alt="" data-id="element-2075" data-mp="1u7mj606sn93e" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-2076" data-mp="3jkhkm9xqnknm">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-2077" data-mp="3eln1f6vuzu2z" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-2078" data-mp="3i3apcqdrm668" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-2079" data-mp="9o0vu6nxy9a2" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-2080" data-mp="3w33g2lpakme7" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-2081" data-mp="4w0s034r2w87" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-2082" data-mp="qk7e6gq53cru">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-2083" data-mp="vgeiy66sui87">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-2084" data-mp="hhoda25wza88">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-2085" data-mp="7soccd7uq4re">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-2086" data-mp="cken2kapaujc">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-2087" data-mp="3uy5rtmmw62t0">
                  <Video className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-2088" data-mp="2rqtdyf0p6ou" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-2089" data-mp="3l1snlutq06k0">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-2090" data-mp="3pxzx1xlbs06p">
                    Webinar Gratuito
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-2091" data-mp="31ey4n03crd6m">
                    Escapa del Dealership
                  </span>
                </div>
              </div>

              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-2092" data-mp="3baj1kjtkdn9i">
                <Calendar className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-2093" data-mp="3pak403ph92r3" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-2094" data-mp="3kd20isu8bfqh">
                  {thursdayLabel}
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-2095" data-mp="3u2lna9l2btqm" />
                <Clock className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-2096" data-mp="3u4oaklutz8rn" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-2097" data-mp="bwyvkuui455u">
                  7PM EST
                </span>
              </div>

              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-2098" data-mp="ezv5o0aebiw6">
                <Ticket className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-2099" data-mp="12ml7b0iu1bg9" />
                <span className="hidden sm:inline" data-id="element-2100" data-mp="17mfzd7ecg72w">Reservar Cupo</span>
                <span className="sm:hidden" data-id="element-2101" data-mp="17l4wrawmx5dd">Reservar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-2102" data-mp="1ckr9zkcgqlm6" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 pt-24 md:pt-28 lg:pt-24 pb-10" data-id="element-2103" data-mp="3ee8dcbtk90b4">
        {/* ============ HERO ============ */}
        <section className="mb-8 md:mb-14 lg:mb-18 text-center" data-id="element-2104" data-mp="1qrm74tdyquf5">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3.5 py-1.5 mb-4 md:mb-8" data-id="element-2105" data-mp="1qq18osoj2rc0">
            <span className="text-emerald-400 text-[11px] md:text-sm font-black uppercase tracking-[0.18em] leading-none" data-id="element-2106" data-mp="1hr66drolu1dz">
              DESCARGA CONFIRMADA ✅
            </span>
          </div>

          <h1 className="text-[26px] md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight mb-3 md:mb-5 lg:mb-6 max-w-5xl mx-auto" data-id="element-2107" data-mp="2afuxcxvy4qc0">
            ¡Listo Hermano! Tu Guía Va En{' '}
            <span className="relative inline-block" data-id="element-2108" data-mp="20he57xl9u5od">
              <span className="relative z-10 text-amber-400" data-id="element-2109" data-mp="20gmaeozi0bz5">
                Camino A Tu Email
              </span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-2110" data-mp="u2my3c5k1olw" />
            </span>
          </h1>

          {/* ============ BOOK DOWNLOAD — replaces video ============ */}
          <div className="max-w-3xl mx-auto mb-4 md:mb-8 lg:mb-10" data-id="element-2111" data-mp="2cwu14s9uv6yn">
            <a href="https://drive.google.com/file/d/1m7uq5UbmI6mfLYG4pFOtj8IAGPl3hRsI/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="group block" aria-label="Descargar El Libro Gratis" data-id="element-2112" data-mp="2hqgeynrr9gw1">
              <div className="relative rounded-xl md:rounded-2xl overflow-hidden border-2 border-amber-500/30 group-hover:border-amber-400 shadow-[0_0_50px_rgba(245,158,11,0.15)] group-hover:shadow-[0_0_60px_rgba(245,158,11,0.3)] bg-[#0f1b35] transition-all duration-300" data-id="element-2113" data-mp="28xl6zmawl72k">
                <img src="https://cdn.magicpatterns.com/uploads/b6UJiQY8AShyrqdN6JMwxG/private_openrouter-generated-image-1778779593292.png" alt="Escapa del Dealership — Libro Gratuito" className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-500" data-id="element-2114" data-mp="2mnooy12r2em7" />

                {/* Hover overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[#0a1428]/40 pointer-events-none" data-id="element-2115" data-mp="1g9h2h442j01g">
                  <div className="bg-gradient-to-b from-amber-400 to-amber-500 text-[#0a1428] px-5 md:px-7 py-2.5 md:py-3.5 rounded-full font-black text-sm md:text-base uppercase tracking-tight shadow-2xl flex items-center gap-2" data-id="element-2116" data-mp="13p0jr7drtu3m">
                    <Download className="w-4 h-4 md:w-5 md:h-5" data-id="element-2117" data-mp="1crjlfo5tm0oa" />
                    Descargar Ahora
                  </div>
                </div>
              </div>
            </a>

            {/* Primary CTA button below the image */}
            <a href="https://drive.google.com/file/d/1m7uq5UbmI6mfLYG4pFOtj8IAGPl3hRsI/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="group relative mt-5 md:mt-6 w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-sm md:text-lg lg:text-xl uppercase tracking-tight rounded-2xl py-4 md:py-5 px-5 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex items-center justify-center gap-2.5 md:gap-3" data-id="element-2118" data-mp="yqp9wwnh7jle">
              <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-2119" data-mp="2b3dzdwym0gsy" />
              <span data-id="element-2120" data-mp="2b607bxpewybp">DESCARGAR EL LIBRO GRATIS</span>
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-2121" data-mp="2g1pasc4jyzda" />
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-2122" data-mp="1ig9xi0utcile" />
            </a>
          </div>

          <p className="text-sm md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-2123" data-mp="1sfirgtpohx7r">
            Te mandé "Escapa del Dealership" a tu email AHORA. Debería llegar en
            menos de 60 segundos. Si no lo ves, revisa tu carpeta de spam.
          </p>

          {/* ============ SECTION 2 — Transition to webinar pitch ============ */}
          <div className="max-w-4xl mx-auto pt-2 md:pt-0 border-t border-white/5 md:border-0" data-id="element-2124" data-mp="w61nbirpqznb">
            <div className="flex flex-col items-center gap-1.5 mt-6 md:mt-0 mb-3 md:mb-6" data-id="element-2125" data-mp="s5hpse389u0n">
              <div className="relative inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-red-500/15 border-2 border-red-500/50 animate-bounce shadow-[0_0_20px_rgba(239,68,68,0.6),0_0_40px_rgba(239,68,68,0.3)]" data-id="element-2126" data-mp="ncyancow6qtq">
                <span className="absolute inset-0 rounded-full bg-red-500/30 animate-ping" data-id="element-2127" data-mp="ddpcs8qwos23" />
                <ArrowDown className="relative w-6 h-6 md:w-7 md:h-7 text-red-400" strokeWidth={3} data-id="element-2128" data-mp="8jbmgkr3pb4a" />
              </div>
              <span className="text-red-400 text-[10px] md:text-xs font-black uppercase tracking-[0.2em] animate-pulse" data-id="element-2129" data-mp="3vly9pggvyk1x">
                Sigue Leyendo
              </span>
            </div>
            <h2 className="text-[clamp(0.95rem,4.2vw,1.25rem)] md:text-3xl lg:text-4xl font-black leading-[1.15] tracking-tight whitespace-nowrap mb-2.5 md:mb-4" data-id="element-2130" data-mp="1tubo5ufrjhcu">
              Pero Antes De Que Te Vayas A Leer El PDF...
            </h2>
            <p className="text-sm md:text-lg text-gray-300 leading-relaxed" data-id="element-2131" data-mp="17n0sdm62l3f4">
              Reservé algo más para ti — el webinar{' '}
              <span className="inline-flex items-center gap-1.5 align-baseline" data-id="element-2132" data-mp="sywb8mmo0zyg">
                <span className="relative flex h-2 w-2 md:h-2.5 md:w-2.5" data-id="element-2133" data-mp="xwoay2tjxqd7">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-2134" data-mp="jy82o7g1jrsy" />
                  <span className="relative inline-flex rounded-full h-2 w-2 md:h-2.5 md:w-2.5 bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-2135" data-mp="o1mml973osbo" />
                </span>
                <span className="font-black text-red-400 tracking-wide uppercase text-xs md:text-sm" data-id="element-2136" data-mp="eylgh8i8j180">
                  EN VIVO
                </span>
              </span>{' '}
              va a cambiar cómo lees la guía.
            </p>
          </div>
        </section>

        {/* ============ SECTION 3 — Por Qué El PDF Solo No Es Suficiente ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-2137" data-mp="3tt3zmsuwrycc">
          <div className="max-w-5xl mx-auto" data-id="element-2138" data-mp="3oxf0gqmswjgk">
            <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-2139" data-mp="3ouizsujkjgof">
              <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] mb-3 md:mb-4" data-id="element-2140" data-mp="7hf6gpwru80c">
                Lo Que El PDF{' '}
                <span className="text-amber-400" data-id="element-2141" data-mp="ggk4lv4f7zbz">NO Puede Hacer</span> Por Ti
              </h2>
              <p className="text-sm md:text-lg text-gray-300" data-id="element-2142" data-mp="giddzi6f4xno">
                El PDF tiene el QUÉ. El webinar tiene el CÓMO.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6" data-id="element-2143" data-mp="qdez82xkpfkz">
              {/* PDF Column */}
              <div className="bg-white/[0.03] border border-white/[0.08] rounded-3xl p-5 md:p-6 lg:p-8" data-id="element-2144" data-mp="lgev3xkaamwi">
                <div className="flex items-center gap-3 mb-6" data-id="element-2145" data-mp="2s6cx4d67iycs">
                  <div className="text-2xl" data-id="element-2146" data-mp="2n81rkemy3a0d">📖</div>
                  <h3 className="text-xl md:text-2xl font-black text-white" data-id="element-2147" data-mp="2n9cukc8kgdqf">
                    EL PDF{' '}
                    <span className="text-gray-400 text-lg font-bold" data-id="element-2148" data-mp="f7unnrfmkxc9">
                      (lo que descargaste):
                    </span>
                  </h3>
                </div>
                <ul className="space-y-2.5" data-id="element-2149" data-mp="tylh13wv84hh">
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-2150" data-mp="oypb2z4ly2za">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-2151" data-mp="17tmeavg7nw9" />
                    <span data-id="element-2152" data-mp="3seeapmu4chpl">Te explica el modelo</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-2153" data-mp="3sg7kvc3xxk2c">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-2154" data-mp="b70ykuqg5chs" />
                    <span data-id="element-2155" data-mp="664wmmpno0f0">Te muestra los nichos</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-2156" data-mp="1ml69y8szoon5">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-2157" data-mp="1mn985g4apo2y" />
                    <span data-id="element-2158" data-mp="1hofsbh1jdkzm">Te da los mensajes</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70 mt-6" data-id="element-2159" data-mp="1p52wviejdia5">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-2160" data-mp="1u5yuje8ao874" />
                    <span data-id="element-2161" data-mp="1g5o58fmmv1o2">NO muestra la herramienta funcionando</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70" data-id="element-2162" data-mp="1k6hsr7w5yegf">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-2163" data-mp="1k8kqke3k5bvp" />
                    <span data-id="element-2164" data-mp="27x40sz663yqf">NO muestra el software construyendo</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70" data-id="element-2165" data-mp="2cux6lr3k6qq6">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-2166" data-mp="1z2z0zq923cyr" />
                    <span data-id="element-2167" data-mp="2353u8nvle7kv">NO responde tus dudas específicas</span>
                  </li>
                </ul>
              </div>

              {/* Webinar Column */}
              <div className="bg-gradient-to-br from-amber-950/30 to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-6 lg:p-8 shadow-[0_0_40px_rgba(245,158,11,0.1)] relative overflow-hidden" data-id="element-2168" data-mp="2qt3nbugdma2m">
                <div className="absolute top-0 right-0 w-32 h-32 bg-amber-400/10 blur-3xl rounded-full" data-id="element-2169" data-mp="35fkf0itd484o" />
                <div className="relative z-10" data-id="element-2170" data-mp="2wh8glum9861o">
                  <div className="flex items-center gap-3 mb-6" data-id="element-2171" data-mp="2wfxdzy4jp4c5">
                    <div className="text-2xl" data-id="element-2172" data-mp="2ridxerkdkfh1">🎯</div>
                    <h3 className="text-xl md:text-2xl font-black text-amber-400" data-id="element-2173" data-mp="2rhvvpfey191q">
                      EL WEBINAR EN VIVO:
                    </h3>
                  </div>
                  <p className="text-white font-bold mb-4" data-id="element-2174" data-mp="2hr9jzwacl2ob">
                    Todo lo del PDF MÁS:
                  </p>
                  <ul className="space-y-2.5" data-id="element-2175" data-mp="2dqz51u4kv1xb">
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-2176" data-mp="28s622vmx2tbe">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-2177" data-mp="23sjmifjm90zf" />
                      <span data-id="element-2178" data-mp="23udxb116bcps">Demo EN VIVO de la herramienta</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-2179" data-mp="1yvjgu5qoi08u">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-2180" data-mp="1op9v3zaeu2y3" />
                      <span data-id="element-2181" data-mp="1tnbgiqvb6ecq">Construyo web completa delante tuyo</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-2182" data-mp="1yp0r65emcq0a">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-2183" data-mp="23n26cf8xc56h" />
                      <span data-id="element-2184" data-mp="15zjzxb2qjf5n">Casos REALES con números reales</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-2185" data-mp="1axv8lihanjma">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-2186" data-mp="1fx7yyd7dj8tm" />
                      <span data-id="element-2187" data-mp="1fvdbos8mr4md">Q&A 30 min — TUS preguntas</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-10 bg-white/[0.02] border border-white/[0.05] rounded-2xl p-6 text-center max-w-3xl mx-auto" data-id="element-2188" data-mp="n7r5dc80plvt">
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-2189" data-mp="s5ixa68nx800">
                Los que leen el PDF y NO van al webinar:{' '}
                <span className="text-white font-bold" data-id="element-2190" data-mp="2oxzu6if5j4fo">
                  5% logra resultados.
                </span>
                <br data-id="element-2191" data-mp="33mvwrzyfvp8w" />
                Los que leen el PDF Y van al webinar:{' '}
                <span className="text-amber-400 font-black text-xl" data-id="element-2192" data-mp="2yw5remq0jme7">
                  40% logra resultados.
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* ============ SECTION 4 — Los 4 Bloques Del Webinar ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-2193" data-mp="38o1wihqiocrx">
          <div className="text-center mb-6 md:mb-8 lg:mb-10" data-id="element-2194" data-mp="3mk5l9vimfsx0">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] max-w-3xl mx-auto" data-id="element-2195" data-mp="3hmnb61svb7nf">
              Lo Que Voy A Mostrar{' '}
              <span className="text-amber-400" data-id="element-2196" data-mp="1s7z6kmqiqtzy">EN VIVO Este Jueves:</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-5 max-w-5xl mx-auto" data-id="element-2197" data-mp="1na7634bt5zk5">
            {blocks.map((b, idx) => <div key={b.title} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-5 md:p-6 lg:p-7 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-2198" data-mp="7peyl9vpt2u5" data-mpi={idx}>
                <div className="flex items-start gap-4" data-id="element-2199" data-mp="3u4pwhj10ipaj">
                  <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-2200" data-mp="3u36gltj9qg9a">
                    <b.icon className="w-5 h-5 lg:w-6 lg:h-6 text-amber-400" data-id="element-2201" data-mp="3l4ky1ydsr18i" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-2202" data-mp="3683qzjcn48rr">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2203" data-mp="369evjldwtkjx">
                      <span className="text-amber-400 text-[10px] lg:text-xs font-black uppercase tracking-[0.18em]" data-id="element-2204" data-mp="3b6ncxjr8hkk4">
                        {b.label}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg lg:text-xl font-black text-white mb-2 leading-snug" data-id="element-2205" data-mp="19dz7d3r4al16">
                      {b.title}
                    </h3>
                    <p className="text-sm md:text-[15px] lg:text-base text-gray-400 leading-relaxed" data-id="element-2206" data-mp="12y8prion1sqw">
                      {b.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* ============ SECTION 5 — Detalles + Countdown ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-2207" data-mp="1qnl1ap7fucwd">
          <div className="max-w-4xl mx-auto" data-id="element-2208" data-mp="1loht4vw5vqk6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-4 mb-5 lg:mb-7" data-id="element-2209" data-mp="1lprubtyb9ev1">
              {[{
              icon: Calendar,
              label: 'Fecha',
              value: `Este ${thursdayLabel.split(' ')[0]}`
            }, {
              icon: Clock,
              label: 'Hora',
              value: '7:00 PM hora Miami (EST)'
            }, {
              icon: Video,
              label: 'Duración',
              value: '90 min + 30 min Q&A'
            }, {
              icon: Monitor,
              label: 'Plataforma',
              value: 'Zoom'
            }, {
              icon: DollarSign,
              label: 'Inversión',
              value: '100% GRATIS',
              highlight: true
            }, {
              icon: AlertTriangle,
              label: 'Importante',
              value: 'Es EN VIVO — NO hay reposición',
              warning: true
            }].map(d => <div key={d.label} className={`flex items-start gap-3 rounded-2xl p-4 lg:p-5 border ${d.warning ? 'bg-red-950/20 border-red-500/30' : d.highlight ? 'bg-amber-500/10 border-amber-500/40 shadow-[0_0_30px_rgba(245,158,11,0.12)]' : 'bg-white/[0.03] border-white/[0.08]'}`} data-id="element-2210" data-mp="a3txjx0bvwdn">
                  <div className={`w-11 h-11 lg:w-12 lg:h-12 rounded-xl flex items-center justify-center flex-shrink-0 border ${d.warning ? 'bg-red-500/10 border-red-500/30' : 'bg-amber-500/10 border-amber-500/30'}`} data-id="element-2211" data-mp="nuz13a6th8t9">
                    <d.icon className={`w-5 h-5 ${d.warning ? 'text-red-400' : 'text-amber-400'}`} data-id="element-2212" data-mp="xrk6vxqnuny5" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-2213" data-mp="3rodmc0znol6">
                    <div className="text-[10px] lg:text-xs font-black uppercase tracking-[0.18em] text-gray-400 mb-1" data-id="element-2214" data-mp="3qwfoujx5erq">
                      {d.label}
                    </div>
                    <div className={`font-black text-base lg:text-lg ${d.warning ? 'text-red-400' : d.highlight ? 'text-amber-400' : 'text-white'}`} data-id="element-2215" data-mp="dqnc51s1i3ug">
                      {d.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* Countdown */}
            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-7 lg:p-9 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-2216" data-mp="3uyr411905quc">
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-2217" data-mp="32g3mtwx4mvyj" />
              <div className="relative" data-id="element-2218" data-mp="2yfbdz4s62t2s">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-2219" data-mp="2obwdut6nemn1">
                  <Clock className="w-3.5 h-3.5 text-amber-400 animate-pulse" data-id="element-2220" data-mp="2t3o2uza5okb2" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-2221" data-mp="2ee8e1ou6qoy0">
                    El Webinar Empieza En:
                  </span>
                </div>

                <div className="grid grid-cols-4 gap-2 md:gap-4 max-w-2xl mx-auto mb-7" data-id="element-2222" data-mp="371ug2snrllir">
                  {[{
                  label: 'Días',
                  value: countdown.days
                }, {
                  label: 'Horas',
                  value: countdown.hours
                }, {
                  label: 'Min',
                  value: countdown.minutes
                }, {
                  label: 'Seg',
                  value: countdown.seconds
                }].map(u => <div key={u.label} className="bg-[#0a1428] border border-amber-500/20 rounded-xl py-3 md:py-4 px-2 md:px-3" data-id="element-2223" data-mp="1qnw0nyg68001">
                      <div className="text-3xl md:text-4xl lg:text-5xl font-black text-amber-400 tabular-nums leading-none mb-1.5" data-id="element-2224" data-mp="o6txy9y8nr70">
                        {String(u.value).padStart(2, '0')}
                      </div>
                      <div className="text-[9px] md:text-[10px] lg:text-xs text-gray-400 uppercase tracking-[0.18em] font-bold" data-id="element-2225" data-mp="x934koqdz0f4">
                        {u.label}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 6 — Caso Real Andrés ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-2226" data-mp="eh0ww2vq2uh0">
          <div className="max-w-5xl mx-auto" data-id="element-2227" data-mp="eg940ztifauf">
            <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-2228" data-mp="j9u02mbjluqz">
              <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] max-w-4xl mx-auto" data-id="element-2229" data-mp="3hz2aytrs91fm">
                Esto Le Pasó A Andrés Cuando{' '}
                <span className="text-amber-400" data-id="element-2230" data-mp="3mw13x8zpn2c8">Vino Al Webinar:</span>
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/20 rounded-3xl p-5 md:p-7 lg:p-9" data-id="element-2231" data-mp="3fdl22ixzlx6d">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8" data-id="element-2232" data-mp="35fwxz2ehrdbj">
                <div className="lg:col-span-3 space-y-2.5 text-gray-300 text-base lg:text-lg leading-relaxed" data-id="element-2233" data-mp="35hztu32bs0o6">
                  <p data-id="element-2234" data-mp="2wf8ie39g94wj">
                    Recuerdas a Andrés del PDF? El vendedor de Toyota en
                    Phoenix.
                  </p>
                  <p className="text-white font-semibold" data-id="element-2235" data-mp="2ro0bbdvldvmj">
                    Aquí está lo que NO te conté:
                  </p>
                  <p data-id="element-2236" data-mp="2mncj4ovmn8qq">Andrés descargó el PDF un lunes. Lo leyó esa noche.</p>
                  <p data-id="element-2237" data-mp="2hs5mg10rz4bb">
                    Pero NO tomó acción ese lunes. Ni el martes. Ni el
                    miércoles.
                  </p>
                  <p data-id="element-2238" data-mp="28q64n6hxrw7b">
                    Andrés iba a ser un 'prospecto frío' más. Otro vendedor que
                    descargó el PDF y siguió con su vida.
                  </p>
                  <p className="text-amber-400 font-bold text-xl mt-6" data-id="element-2239" data-mp="1y75cpncbgem6">
                    Hasta que vino al webinar el jueves.
                  </p>
                </div>

                {/* Pull quote */}
                <div className="lg:col-span-2 relative bg-white/[0.04] border border-amber-500/30 rounded-2xl p-5 lg:p-6" data-id="element-2240" data-mp="1u37gbkedlhwt">
                  <Quote className="w-7 h-7 text-amber-400/60 mb-3" data-id="element-2241" data-mp="2hsjk24qxoxrq" />
                  <p className="text-white text-base lg:text-lg font-medium italic leading-snug mb-4" data-id="element-2242" data-mp="2ludi059qvno7">
                    "En el PDF entendí el modelo. En el webinar VI que era real.
                    Cuando viste la herramienta encontrar 200 dentistas en
                    Phoenix en menos de un minuto, dije 'esto es mi salida'.
                    Cuando construiste la web del Dr. González en vivo, dije 'yo
                    puedo hacer esto'. Esa noche le dije a Laura: 'me apunto al
                    programa'."
                  </p>
                  <div className="flex items-center gap-2.5" data-id="element-2243" data-mp="3evv2ujgs34vy">
                    <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-2244" data-mp="3avuhsfz6bvfx">
                      <User className="w-4 h-4 text-amber-400" data-id="element-2245" data-mp="3olo52tv167nj" />
                    </div>
                    <div data-id="element-2246" data-mp="3joxp06j87c24">
                      <div className="text-white font-black text-sm" data-id="element-2247" data-mp="3joo7l7c8yd81">
                        Andrés
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center bg-white/[0.02] border border-white/[0.05] rounded-xl p-5" data-id="element-2248" data-mp="2rz2y45fpzebc">
                <p className="text-gray-300 text-lg" data-id="element-2249" data-mp="30xellylahvzk">
                  El PDF te informa. El webinar te decide.{' '}
                  <span className="text-white font-bold" data-id="element-2250" data-mp="l5r2p73423zr">
                    Andrés es la prueba viviente.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 7 — Botón Principal ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18 text-center" data-id="element-2251" data-mp="2quax32kipn1y">
          <div className="max-w-3xl mx-auto" data-id="element-2252" data-mp="2qwnenemd5veh">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] mb-3 md:mb-4" data-id="element-2253" data-mp="2vte58vvso9e5">
              Reserva Tu Cupo Para El Jueves:
            </h2>

            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-3.5 py-1.5 md:px-4 md:py-2 mb-4 md:mb-5 max-w-full" data-id="element-2254" data-mp="2zswf8wm2v027">
              <span className="text-base md:text-xl flex-shrink-0" data-id="element-2255" data-mp="39ruccnxkk1wt">🔥</span>
              <span className="text-red-400 text-[11px] md:text-base font-bold leading-tight text-left" data-id="element-2256" data-mp="3el6mjt1i4661">
                Ya hay más de 340 vendedores registrados — los cupos son
                limitados
              </span>
            </div>

            <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-xl lg:text-2xl uppercase tracking-tight rounded-2xl py-5 md:py-8 px-4 md:px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden mb-4 md:mb-5" data-id="element-2257" data-mp="3niqqxaunuikv">
              <span className="relative z-10 flex items-center justify-center gap-3" data-id="element-2258" data-mp="12yv3021uhr99">
                👉 RESERVAR MI CUPO GRATIS PARA EL JUEVES
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-2259" data-mp="1vmqumsck4sz6" />
            </button>

            <div className="grid grid-cols-2 md:flex md:flex-row md:items-center md:justify-center gap-x-3 gap-y-2 md:gap-8 text-xs md:text-sm text-gray-400 mb-5 md:mb-6 max-w-md md:max-w-none mx-auto" data-id="element-2260" data-mp="1lve3k2yl26u7">
              <span className="flex items-center gap-1.5" data-id="element-2261" data-mp="2ej0ddsyem7pi">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-2262" data-mp="2xhlgywvq0k4m" />
                <span className="truncate" data-id="element-2263" data-mp="32fwsrd5kt4ph">30 segundos</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-2264" data-mp="2ooi4orwtadbk">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-2265" data-mp="2oo05bmeurizf" />
                <span className="truncate" data-id="element-2266" data-mp="2so0t3xnud6j5">100% gratis</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-2267" data-mp="2epaw0i10v6us">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-2268" data-mp="2jovwiwvubn9m" />
                <span className="truncate" data-id="element-2269" data-mp="25pnrhnczxkxi">Confirmación inmediata</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-2270" data-mp="29qzmk8en2yd3">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-2271" data-mp="29rho9kk2m4se" />
                <span className="truncate" data-id="element-2272" data-mp="3yj26xyjcwgc">Recordatorios automáticos</span>
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2273" data-mp="7ythx2c4r18e">
              <button className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-2274" data-mp="1si6p8v3kcfmb">
                <CalendarPlus className="w-4 h-4 text-amber-400" data-id="element-2275" data-mp="2291hqh7ekbg7" />
                Agregar a Google Calendar
              </button>
              <button className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-2276" data-mp="2c5mkevvy9agv">
                <CalendarPlus className="w-4 h-4 text-amber-400" data-id="element-2277" data-mp="2l6ccboi3agpb" />
                Agregar a Apple Calendar
              </button>
              <button className="flex items-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-2278" data-mp="2g6zq95z1ldns">
                <MessageCircle className="w-4 h-4" data-id="element-2279" data-mp="lurphc01i2k3" />
                Activar Recordatorios
              </button>
            </div>
          </div>
        </section>

        {/* ============ SECTION 8 — CTA Final Emocional ============ */}
        <section className="mb-8" data-id="element-2280" data-mp="9puj0400uqmt">
          <div className="max-w-3xl mx-auto" data-id="element-2281" data-mp="9pku6jqpqpip">
            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-8 lg:p-10 shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-2282" data-mp="9rxgf93i7m1k">
              <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-2283" data-mp="3e65c9gf27exv" />
              <div className="relative" data-id="element-2284" data-mp="3i7h4zut8cgaa">
                <h2 className="text-xl md:text-3xl font-black leading-[1.15] mb-4 md:mb-6 text-center" data-id="element-2285" data-mp="3n3pi72nv9zet">
                  Si Sigues Aquí, Es Por Una Razón
                </h2>

                <div className="space-y-2.5 md:space-y-3 text-gray-300 text-sm md:text-lg leading-relaxed mb-5 md:mb-6" data-id="element-2286" data-mp="12erxdw1443aa">
                  <p data-id="element-2287" data-mp="17cjseyx205ip">Llegaste hasta el final.</p>
                  <p data-id="element-2288" data-mp="17ffp6jx60o5k">
                    La mayoría que descarga el PDF cierra esta página en los
                    primeros 30 segundos. Tú no.
                  </p>
                  <p data-id="element-2289" data-mp="2mx2kfzpqadh9">Eso me dice algo importante de ti.</p>
                </div>

                <div className="text-center mb-5 md:mb-6" data-id="element-2290" data-mp="2i4smbwegm73w">
                  <p className="text-lg md:text-3xl font-black text-white leading-snug mb-4 md:mb-5" data-id="element-2291" data-mp="2d6r2385as1qu">
                    ¿El jueves a las 7 PM vas a estar viendo la Masterclass
                    conmigo?
                  </p>

                  <button type="button" onClick={() => setShowModal(true)} className="group relative inline-flex items-center justify-center gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-sm md:text-xl uppercase tracking-tight rounded-xl py-4 px-5 md:px-8 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden w-full md:w-auto" data-id="element-2292" data-mp="245t69d50j0jc">
                    <span className="relative z-10" data-id="element-2293" data-mp="gxxfre95p0jy">
                      👉 SÍ, QUIERO RESERVAR MI CUPO
                    </span>
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-2294" data-mp="cw2eg9r86n66" />
                  </button>
                </div>

                <div className="border-t border-white/10 pt-5 md:pt-8 space-y-3 md:space-y-4 text-gray-400 text-sm md:text-lg italic" data-id="element-2295" data-mp="308s5ynpffb7">
                  <p data-id="element-2296" data-mp="vma4pr9ttj4y">Hermano, nos vemos el jueves a las 7 PM hora Miami.</p>
                  <p data-id="element-2297" data-mp="qw3h9ur1w4oa">Y mientras tanto — abre el email, lee el PDF.</p>
                  <p data-id="element-2298" data-mp="qu8vyfbvaajo">
                    Empieza por el capítulo 4 (la historia de Andrés). Te va a
                    abrir los ojos.
                  </p>
                  <p className="font-bold text-white not-italic mt-5 md:mt-6" data-id="element-2299" data-mp="1jcnvlegodbxy">
                    — Gabriel
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-2300" data-mp="1lydkhq1w41mm" />

      {/* Registration Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-2301" data-mp="1qv3xg4ieeh3t">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)] max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-2302" data-mp="1vx30fda87c08">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-2303" data-mp="29urmupjxyr7e">
              <X className="w-6 h-6" data-id="element-2304" data-mp="2em9ntdlysrsd" />
            </button>

            <div className="text-center mb-6" data-id="element-2305" data-mp="2jkud4hzohr21">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-2306" data-mp="2jmnlc1pxwjc5">
                <Ticket className="w-6 h-6 text-amber-400" data-id="element-2307" data-mp="2skr8t3khjq6l" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-2308" data-mp="tgiq7eiv9fa4">
                Reservar Mi Cupo
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-2309" data-mp="oizb6cecgyh4">
                Masterclass EN VIVO — Este {thursdayLabel} 7PM Miami
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2310" data-mp="xhkqlyoirxdo">
              <div className="space-y-1" data-id="element-2311" data-mp="xfzwuba14igv">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-2312" data-mp="1c67h8wjlkbk7">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-2313" data-mp="177ntqrpcurpq">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-2314" data-mp="1l7f5elsefw0k">
                    <User className="h-5 w-5 text-gray-500" data-id="element-2315" data-mp="1h5k4hiedrknb" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-2316" data-mp="3mys60ync3hqt" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-2317" data-mp="2z48cw3sydh9p">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-2318" data-mp="2z36wdjt642kl">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-2319" data-mp="2p5sinrymprvz">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-2320" data-mp="2p4r7zoliz7es">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-2321" data-mp="2u66tfhrm7fxp" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-2322" data-mp="2g5vxi0bg7b5o" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-2323" data-mp="2ff70zykoaafa">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-2324" data-mp="2agm9qonef12z">
                  WhatsApp (Para Recordatorios)
                </label>
                <div className="flex gap-2" data-id="element-2325" data-mp="25fy8zb9db5vk">
                  <div className="relative w-1/3" data-id="element-2326" data-mp="21g7ofpafplzh">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-2327" data-mp="21fedec4g0abj">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-2328" data-mp="1wi5sw4vtnu74" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-2329" data-mp="1rojrx9z0ter5">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-2330" data-mp="1dsfyvjzvvcg9">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-2331" data-mp="3pdoxdjowej51">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-2332" data-mp="3pcds1fft13bt">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-2333" data-mp="3tftmc54eirlc" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-2334" data-mp="27pmtgyxmcx3" />
                  </div>
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer group pt-1" data-id="element-2335" data-mp="2i0erb6vr69sv">
                <div className="relative flex-shrink-0 mt-0.5" data-id="element-2336" data-mp="2hyansq1rnct4">
                  <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-2337" data-mp="2mxnb1bwjulw8" />
                  <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-2338" data-mp="3lb2ddkoci8jz">
                    {smsConsent && <CheckCircle2 className="w-3.5 h-3.5 text-[#0a1428]" strokeWidth={3} data-id="element-2339" data-mp="3v141udkm1szf" />}
                  </div>
                </div>
                <span className="text-[11px] md:text-xs text-gray-400 leading-relaxed" data-id="element-2340" data-mp="37cb0u2p4suxy">
                  Acepto recibir mensajes SMS con recordatorios e información
                  del webinar. Puedo cancelar en cualquier momento respondiendo
                  STOP.
                </span>
              </label>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-2341" data-mp="3bbbihhvvhrjd">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-2342" data-mp="132wytqshkhuw">
                  {isSubmitting ? <>Reservando...</> : <>
                      <Ticket className="w-4 h-4 md:w-5 md:h-5" data-id="element-2343" data-mp="u5csw4johxdy" />
                      RESERVAR MI CUPO AHORA
                      <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-1" data-id="element-2344" data-mp="1hunyq0fvyhyy" />
                    </>}
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-2345" data-mp="184umcx7x5ytn" />
              </button>

              <div className="flex items-center justify-center gap-1.5 text-[10px] md:text-xs text-gray-500 pt-1" data-id="element-2346" data-mp="20rytb7qkon82">
                <Lock className="w-3 h-3" data-id="element-2347" data-mp="25lb5ujhz93kg" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}